import React from 'react'
import PropTypes from 'prop-types'
import Decimal from 'decimal.js'

import { currencyFormat, decimalForInput } from 'utils/format'

import { Checkbox } from 'ui-components/Checkbox'
import { DescList } from 'ui-components/DescList'
import { DescItemList } from 'ui-components/DescItemList'
import { Container, InputFormStyled } from './styles'

export default function Price({
  price,
  onChange,
  selected,
  onToggleSelection,
}) {
  const handleChange = (evt) => {
    const value = decimalForInput(evt.target.value)
    onChange({ value, id: price.id })
  }

  const handleSelect = () => {
    onToggleSelection(price.id, !selected)
  }

  const getDiff = () => {
    if (price.diff) return currencyFormat(price.diff)

    const sellingPrice = Decimal(price.selling_price)
    const diff = sellingPrice.sub(price.current_price)

    return diff.isZero() ? '---' : currencyFormat(diff)
  }

  return (
    <DescList>
      <Container>
        <DescItemList label="">
          <Checkbox
            color="primary"
            checked={selected}
            onChange={handleSelect}
          />
        </DescItemList>

        <DescItemList label="Nome">
          {price.name}
        </DescItemList>

        <DescItemList label="R$ Atual">
          {currencyFormat(price.current_price)}
        </DescItemList>

        <DescItemList label="R$ Diferença">
          {getDiff()}
        </DescItemList>

        <InputFormStyled
          fullWidth
          label="R$ Valor"
          type="text"
          name="price"
          value={currencyFormat(price.selling_price)}
          onChange={handleChange}
        />
      </Container>
    </DescList>
  )
}

Price.propTypes = {
  price: PropTypes.objectOf(PropTypes.any).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  onToggleSelection: PropTypes.func.isRequired,
}
